import React, { ReactNode } from 'react';
import { TextSkeleton } from '@visalex/core';

import cx from 'clsx';

import { Helper } from './components/Helper/Helper';
import { Label } from './components/Label/Label';
import { ValidationMessage } from './components/ValidationMessage/ValidationMessage';

import styles from './FormGroup.module.scss';

export interface IExtendedClassNames {
  formGroup?: string;
  formLabel?: string;
  formLabelWrapper?: string;
  formHelper?: string;
  formHelperWrapper?: string;
  formErrors?: string;
  skeleton?: string;
}

export type FormGroupEssentialProps = {
  label?: ReactNode;
  helper?: ReactNode;
  isLoading?: boolean;

  /**
   * Whether the form field group should be aligned into a line
   */
  inline?: boolean;
  valid?: boolean | null;
  extendedClassNames?: IExtendedClassNames;
};

export type FormGroupProps = FormGroupEssentialProps & {
  name?: string;
  children?: ReactNode;
  validationMessage?: ReactNode;
};

/**
 * Creates an envelope around a regular form fields
 */
export function FormGroup(props: FormGroupProps) {
  const {
    name,
    extendedClassNames: ecx = {},
    label,
    helper,
    isLoading,
    validationMessage,
    inline,
    valid,
    children,
  } = props;

  return (
    <div className={cx(ecx.formGroup, styles['form-group'], inline && styles['form-group--inline'])}>
      <Label
        label={label}
        htmlFor={name || ''}
        labelClassName={ecx.formLabel}
        labelWrapperClassName={ecx.formLabelWrapper}
      />

      {isLoading ? (
        <TextSkeleton width="100%" className={cx(styles['form-group__skeleton'], ecx.skeleton)} />
      ) : (
        children
      )}
      <Helper helper={helper} className={ecx.formHelper} wrapperClassName={ecx.formHelperWrapper} />
      <ValidationMessage
        message={validationMessage}
        className={cx(ecx.formErrors, styles[`validation-message--${valid ? 'valid' : 'invalid'}`])}
      />
    </div>
  );
}
